// extracted by mini-css-extract-plugin
export var backdropBlur = "_e1-0";
export var contentCard = "_e1-5";
export var frame = "_e1-2";
export var image = "_e1-4";
export var imagePane = "_e1-3";
export var modal = "_e1-1";